(function () {

  var SDK = window.TrackingSDK;
  if (!SDK) return;

  var track = SDK.track;
  var fired = new Set();

  function once(key) {
    if (fired.has(key)) return false;
    fired.add(key);
    setTimeout(function () { fired.delete(key); }, 5000);
    return true;
  }

  function parse(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  // =============================
  // PAGEVIEW
  // =============================
  function trackPageview() {
    var T = window.__TRACKING__;
    if (!T) return Promise.resolve();
    return track.pageview(T.page || {}, T.user || {});
  }

  // =============================
  // LIST VIEW  —  data-track-list > data-track-product
  // =============================
  function trackList(root) {
    root.querySelectorAll('[data-track-list]').forEach(function (listEl) {
      var listName = listEl.dataset.trackList || '';
      if (!listName || !once('list:' + listName)) return;

      var products = [];
      listEl.querySelectorAll('[data-track-product]').forEach(function (el) {
        // Skip Swiper duplicate slides
        if (el.closest('.swiper-slide-duplicate')) return;
        var p = parse(el.dataset.trackProduct);
        if (p) products.push(p);
      });

      if (products.length) track.viewItemList(products, listName);
    });
  }

  // =============================
  // PDP  —  view_item
  // =============================
  function trackPDP() {
    var T = window.__TRACKING__;
    if (!T || !T.product) return;

    var p = T.product;
    if (!p.variants || !p.variants.length || !once('pdp:' + p.id)) return;

    var urlVariantId = new URLSearchParams(location.search).get('variant');
    var selectedVariant = urlVariantId && p.variants.find(function (x) { return String(x.id) === urlVariantId; });
    var v = selectedVariant
          || p.variants.find(function (x) { return x.available; })
          || p.variants[0];

    track.viewItem({
      id:               p.id,
      variant_id:       selectedVariant ? v.id : null,
      title:            p.title,
      category:         p.category,
      category2:        p.category2,
      color:            p.color,
      sku:              v.sku,
      price:            v.price,
      compare_at_price: v.compare_at_price,
      available:        v.available,
      variants:         p.variants,
      variant_title:    v.title
    });
  }

  // =============================
  // VARIANT CHANGE  —  view_item on size/option selection
  // =============================
  function trackVariantChange(event) {
    var T = window.__TRACKING__;
    if (!T || !T.product) return;

    var variant = event && event.data && event.data.variant;
    if (!variant) return;

    var p = T.product;

    track.viewItem({
      id:               p.id,
      variant_id:       variant.id,
      title:            p.title,
      category:         p.category,
      category2:        p.category2,
      color:            p.color,
      sku:              variant.sku,
      price:            variant.price,
      compare_at_price: variant.compare_at_price,
      available:        variant.available,
      variants:         p.variants,
      variant_title:    variant.title
    });
  }

  // =============================
  // SELECT ITEM  —  click on product link
  // =============================
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-track-click]');
    if (!link) return;

    var card   = link.closest('[data-track-product]');
    var listEl = card && card.closest('[data-track-list]');
    if (!card) return;

    var data     = parse(card.dataset.trackProduct);
    var listName = listEl ? listEl.dataset.trackList : '';
    if (!data) return;

    var index = 0;
    if (listEl) {
      var cards = listEl.querySelectorAll('[data-track-product]');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i] === card) { index = i; break; }
      }
    }

    track.selectItem(data, listName, index);
  });

  // =============================
  // CART VIEW
  // =============================
  function trackCartView() {
    if (location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/') !== '/cart') return;
    fetchCart().then(function (c) {
      lastCart = c;
      if (once('cart:view')) track.viewCart(c);
    });
  }

  // =============================
  // CART DIFF  —  add_to_cart / remove_from_cart
  // =============================
  var lastCart = null;

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function diffCarts(oldC, newC) {
    var changes = { added: [], removed: [] };
    if (!oldC) return changes;

    var oldMap = {}, newMap = {};
    oldC.items.forEach(function (i) { oldMap[i.key] = i; });
    newC.items.forEach(function (i) { newMap[i.key] = i; });

    // Increased quantity or new item
    newC.items.forEach(function (i) {
      var oldQ = oldMap[i.key] ? oldMap[i.key].quantity : 0;
      if (i.quantity > oldQ) changes.added.push({ item: i, qty: i.quantity - oldQ });
    });

    // Decreased quantity or fully removed item
    oldC.items.forEach(function (i) {
      var newQ = newMap[i.key] ? newMap[i.key].quantity : 0;
      if (i.quantity > newQ) changes.removed.push({ item: i, qty: i.quantity - newQ });
    });

    return changes;
  }

  function handleCartUpdate(newCart) {
    var changes = diffCarts(lastCart, newCart);
    lastCart = newCart;

    var all = changes.added.concat(changes.removed);
    var handlesToFetch = {};
    all.forEach(function (c) {
      if (SDK.Attribution.get('vstock:' + c.item.variant_id) === null && c.item.handle) {
        handlesToFetch[c.item.handle] = true;
      }
    });

    var fetches = Object.keys(handlesToFetch).map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) {
            SDK.Attribution.set('vstock:' + v.id, v.inventory_quantity || 0);
          });
        })
        .catch(function () {});
    });

    Promise.all(fetches).then(function () {
      changes.added.forEach(function (c) { track.addToCart(c.item, c.qty); });
      changes.removed.forEach(function (c) { track.removeFromCart(c.item, c.qty); });
    });
  }

  // Intercept fetch for cart mutations
  var _origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return _origFetch.apply(this, args).then(function (res) {
      var url = typeof args[0] === 'string' ? args[0]
              : (args[0] && args[0].url) ? args[0].url : '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        // Try to read the response body directly (change/update/clear return the full cart).
        // Clone first so the original response is still consumable by the theme.
        res.clone().json().then(function (data) {
          if (data && Array.isArray(data.items)) {
            handleCartUpdate(data);
          } else {
            // add.js returns a single line item, not the full cart — fetch separately
            fetchCart().then(handleCartUpdate);
          }
        }).catch(function () {
          fetchCart().then(handleCartUpdate);
        });
      }
      return res;
    });
  };

  // =============================
  // PROMOTIONS  —  view_promotion / select_promotion
  // =============================
  var viewedPromos = new Set();

  function parsePromo(el) { return parse(el.dataset.trackPromo); }

  function observePromos(root) {
    var promos = root.querySelectorAll('[data-track-promo]');
    if (!promos.length) return;

    if (!window.IntersectionObserver) {
      // Fallback: fire immediately for all visible promos
      promos.forEach(function (el) {
        var p = parsePromo(el);
        if (!p || viewedPromos.has(p.creative_slot)) return;
        viewedPromos.add(p.creative_slot);
        track.viewPromotion(p);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var p = parsePromo(entry.target);
        if (!p || viewedPromos.has(p.creative_slot)) return;
        viewedPromos.add(p.creative_slot);
        track.viewPromotion(p);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    promos.forEach(function (el) { io.observe(el); });
  }

  // select_promotion: only fires when clicking a link or button inside a promo
  document.addEventListener('click', function (e) {
    if (!e.target.closest('a, button')) return;
    var promo = e.target.closest('[data-track-promo]');
    if (!promo) return;
    var p = parsePromo(promo);
    if (p) track.selectPromotion(p);
  });

  // =============================
  // MUTATION OBSERVER  —  handle dynamically added content
  // =============================
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        trackList(n);
        observePromos(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // =============================
  // INIT
  // =============================

  // Initialise lastCart eagerly so it is ready before any user interaction
  fetchCart().then(function (c) { lastCart = c; });

  subscribe(PUB_SUB_EVENTS.variantChange, trackVariantChange);

  document.addEventListener('DOMContentLoaded', function () {
    trackPageview().then(function () {
      trackPDP();
      trackList(document);
      trackCartView();
      observePromos(document);
    });
  });

})();
